module.exports = "/assets/data/4a4eda9b200f42b9c4c414838cc7df81-NR3.data.json";